import { MemoryReactionsStore, ReactionServiceClient } from '@atlaskit/reactions';
import { META_REACTIONS_URL_NAME } from './constants';
var getMeta = function getMeta(name) {
  var node = document.querySelector("meta[name=\"".concat(name, "\"]"));
  var metaValue = node && node.getAttribute('content');
  return metaValue;
};
var url = function url() {
  var _getMeta;
  return (_getMeta = getMeta(META_REACTIONS_URL_NAME)) !== null && _getMeta !== void 0 ? _getMeta : '';
};
var client = function client() {
  return new ReactionServiceClient(url());
};
var reactionStoreFactory = function reactionStoreFactory() {
  return new MemoryReactionsStore(client());
};
export { reactionStoreFactory };